export const NAV_ARIA_LABEL_DEFAULT = 'Fil d\'Ariane';
export const EXPAND_BTN_ARIA_LABEL_DEFAULT = 'Étendre le fil d\'Ariane';

export const ICONS_FONT_CHEVRON_UNICODE = '\uF107';
